import { render } from "./foot.vue?vue&type=template&id=16fcbd0b&scoped=true&bindings={}"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"

import "./foot.vue?vue&type=style&index=0&id=16fcbd0b&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-16fcbd0b"

export default script